export default "__VITE_ASSET__Boc2eGsP__"